enum MediaQueryTypeEnum {
	all = 'all',
	print = 'print',
	screen = 'screen'
}

export default MediaQueryTypeEnum;
